module.exports = __webpack_public_path__ + "img/tab.c1848b99.png";